/**
 * Idle timer
 * @param {function()} callback - A callback function to run after timeout
 * @param {int} interval - Interval timeout time in seconds, default 2 minutes (120 seconds)
 */
export default (onIdleTimeout, interval = 120) => {
  var t;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer;
  window.ontouchstart = resetTimer;
  window.ontouchmove = resetTimer;
  window.onclick = resetTimer;
  window.onkeydown = resetTimer;
  window.addEventListener("scroll", resetTimer, true);

  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(() => {
      onIdleTimeout();
      resetTimer();
    }, interval * 1000);
  }
};
